export const ROLE_ADMIN_PERFORM = 'ROLE_ADMIN_PERFORM';
export const ROLE_PLAYER = 'ROLE_PLAYER';
export const ROLE_USER = 'ROLE_USER';
